<template>
  <div>
    
    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="title is-4">
          タブのスワイプ操作
        </p>
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          1. 削除
        </p>
        <p class="subtitle subtitle-detail">
          この先いらないもの。右へ大きくスワイプ。
        </p>
        <img src="../../assets/tutorial2_1.png" width="350px">
      </div>
    </section>


    <section class="hero">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          2. 完了
        </p>
        <p class="subtitle subtitle-detail">
          もういらないけど、いつか欲しくなるかも。<br>  
          記録やシェア用にとっておきたいもの。
        </p>
        <img src="../../assets/tutorial2_2.png" width="350px">
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          3. いつか
        </p>
        <p class="subtitle subtitle-detail">
          また今度いるけど、今はいらないもの。<br>
          指定した時間に通知が届きます。<br>Foreverは通知しません。
        </p>
        <img src="../../assets/tutorial2_3.png" width="350px">
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          4. 表示切り替え
        </p>
        <p class="subtitle subtitle-detail">
          今欲しいタブにフォーカスできます。
        </p>
        <img src="../../assets/tutorial2_4.gif" width="350px">
      </div>
    </section>

  </div>
</template>

<script>
export default {
    name: 'ios',
    mounted() {
		document.title = "2.タブのスワイプ方法"
	},
};
</script>

<style lang="scss" scoped>
.is-white {
    background-color:#fcfcfc !important;
}

.title, .subtitle {
  letter-spacing: 0.1em;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif;
}

.title {
 opacity: 0.85;
}

.hero-body {
  padding-left:12px;
  padding-right:12px;
}

.subtitle-detail {
    font-size: 0.9rem;
}
</style>

